// project imports
import config from 'config';

// action - state management
import * as actionTypes from './actions';

const readInitialTheme = () => {
  try {
    const u = JSON.parse(localStorage.getItem('user') || 'null');
    if (u && Number(u.role) < 10) return 'light';
  } catch (e) {
    /* ignore */
  }
  try {
    return localStorage.getItem('theme') || 'dark';
  } catch (e) {
    return 'dark';
  }
};

export const initialState = {
  isOpen: [], // for active default menu
  defaultId: 'default',
  fontFamily: config.fontFamily,
  borderRadius: config.borderRadius,
  opened: true,
  theme: readInitialTheme(),
  locale: 'zh'
};

// ==============================|| CUSTOMIZATION REDUCER ||============================== //

const customizationReducer = (state = initialState, action) => {
  let id;
  switch (action.type) {
    case actionTypes.MENU_OPEN:
      id = action.id;
      return {
        ...state,
        isOpen: [id]
      };
    case actionTypes.SET_MENU:
      return {
        ...state,
        opened: action.opened
      };
    case actionTypes.SET_FONT_FAMILY:
      return {
        ...state,
        fontFamily: action.fontFamily
      };
    case actionTypes.SET_BORDER_RADIUS:
      return {
        ...state,
        borderRadius: action.borderRadius
      };
    case actionTypes.SET_THEME:
      return {
        ...state,
        theme: action.theme
      };
    case actionTypes.SET_LOCALE:
      return {
        ...state,
        locale: action.locale
      };
    default:
      return state;
  }
};

export default customizationReducer;
